import React from 'react';
import PropTypes from 'prop-types';
import { useNumericMenu } from 'react-instantsearch';

export function NumericMenu(props) {
  const { items, refine } = useNumericMenu(props);

  const { className } = props;

  return (
    <div
      className={`ais-NumericMenu ${
        !items.length ? 'ais-NumericMenu--noRefinement' : ''
      } ${className || ''}`}
    >
      <ul className="ais-NumericMenu-list">
        {items.map(item => (
          <li
            key={item.value}
            className={`ais-NumericMenu-item ${
              item.isRefined ? 'ais-NumericMenu-item--selected' : ''
            }`}
          >
            <label className="ais-NumericMenu-label">
              <input
                className="ais-NumericMenu-radio"
                type="radio"
                checked={item.isRefined}
                onChange={() => refine(item.value)}
              />
              <span className="ais-NumericMenu-labelText">{item.label}</span>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
}

NumericMenu.propTypes = {
  className: PropTypes.string,
};

NumericMenu.defaultProps = {
  className: '',
};

export default NumericMenu;
